import { Toaster } from 'sonner'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import './maplibre.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { disableReactDevTools } from '@fvilers/disable-react-devtools'
import './index.css'
import { NuqsAdapter } from 'nuqs/adapters/react-router'
import QueryClientProvider from '@/pages/enterprise/query-client-provider'

if (process.env.NODE_ENV === 'production') {
  disableReactDevTools()
}

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <NuqsAdapter>
    <BrowserRouter>
      <QueryClientProvider>
        <App />
      </QueryClientProvider>
      <Toaster />
    </BrowserRouter>
  </NuqsAdapter>
)

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
